<template>
    <div class="home">
    <NavBar @user-subscriber-status="handleSubscriberStatus" />    
        <div class="switch">
            <div class="d-flex justify-content-center">
                <div class="form-check form-switch">
                    <input class="form-check-input" type="checkbox" role="switch" id="customAssessmentSwitch" @change="handleCustomAssessmentSwitch">
                    <label class="form-check-label" for="customAssessmentSwitch">Custom Assessment</label>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <DispatchesLeft v-if="!userIsUnlimitedSubscriber" :user-is-unlimited-subscriber="userIsUnlimitedSubscriber"/>
            </div>
        </div>
        <DispatchAssessment v-if="!customAssessmentSwitchSelected" />
        <DispatchCustomAssessment v-if="customAssessmentSwitchSelected" />
    </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import DispatchAssessment from '@/components/DispatchAssessment.vue';
import DispatchCustomAssessment from '@/components/DispatchCustomAssessment.vue';
import DispatchesLeft from '@/components/Subscription/DispatchesLeft.vue';

export default {
  name: 'AssessmentsView',
  components: {
      NavBar,
      DispatchAssessment,
      DispatchCustomAssessment,
      DispatchesLeft
  }, 
  data() {
    return {
        customAssessmentSwitchSelected: false,
        userIsUnlimitedSubscriber: false
    }
  },
  methods: {
    handleCustomAssessmentSwitch() {
        this.customAssessmentSwitchSelected = !this.customAssessmentSwitchSelected;
    },
    handleSubscriberStatus(userIsUnlimitedSubscriber) {
        this.userIsUnlimitedSubscriber = userIsUnlimitedSubscriber;
        console.log('user is subscriber: ' + this.userIsUnlimitedSubscriber);
    },
    preventRightClick(event) {
      event.preventDefault();
    }
  }
}
</script>
<style scoped>
.switch {
    background-color: #181a1b;
    width: 60%;
    min-width: 100%;
}
.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/main-background.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    
}
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}

.no-select {
  user-select: none; /* Standard syntax */
  -webkit-touch-callout: none; /* iOS Safari */
}
</style>